import { breakpointsTailwind, useElementSize } from '@vueuse/core';
import { computed, ref } from 'vue';

export const DEVICE_BREAKPOINT = Object.freeze({
  MOBILE: 'mobile',
  TABLET: 'tablet',
  LAPTOP: 'laptop',
  DESKTOP: 'desktop',
});

const containerEl = ref<HTMLElement | null>(null);

const { width: mainElWidth } = useElementSize(containerEl);
const { md, lg, '2xl': doubleXl } = breakpointsTailwind;

const isBetween = (value: number, min: number, max: number) => value > min && value <= max;
const isGreater = (value: number, valueToCompare: number) => value > valueToCompare;

export const setContainerEl = (el: HTMLElement | null) => {
  containerEl.value = el;
};

export const deviceBreakpoint = computed(() => {
  if (!containerEl.value) { return DEVICE_BREAKPOINT.MOBILE; }

  if (isBetween(mainElWidth.value, md, lg)) { return DEVICE_BREAKPOINT.TABLET; }
  if (isBetween(mainElWidth.value, lg, doubleXl)) { return DEVICE_BREAKPOINT.LAPTOP; }
  if (isGreater(mainElWidth.value, doubleXl)) { return DEVICE_BREAKPOINT.DESKTOP; }
  return DEVICE_BREAKPOINT.MOBILE;
});
